// ─── Editable content ────────────────────────────────────────────────────────
// One short layperson description per policy id. Shown in the
// hover-description section at the bottom of the policy tooltips. Cmd-click
// POLICY_DESCRIPTIONS at a render site to jump straight to these strings.
// Keep each ≤ ~78 chars so it sits on ONE line in the in-canvas hover detail
// (10.5px sans across the HUD's width — same budget as the AI Policies line).

export const POLICY_DESCRIPTIONS: Record<string, string> = {
  "baseline-ai-company-transparency":
    "Labs must report capabilities, safety cases, and incidents to regulators.",
  "massive-ai-alignment-subsidies":
    "Public funding floods safety work so alignment keeps pace with capabilities.",
  "us-china-chip-audit":
    "Both governments declare and verify their advanced chip stockpiles.",
  "total-research-transparency":
    "All AI R&D under the deal is fully visible to the other side's verifiers.",
  "pause-on-ai-r-d":
    "Frontier capability work halts worldwide until safety catches up.",
  "safety-regulation-for-large-training-runs":
    "Training runs and capabilities experiments need approval and a safety review.",
  "compute-self-destruct-switches":
    "Datacenters have remote kill switches and backup destruction mechanisms.",
  "cap-and-trade-for-robots-and-compute":
    "A cap on robots and chip production to slow runaway industrial explosion.",
  "citizen-s-dividend":
    "Everyone gets regular cash payments from taxes on AI profits.",
  "universal-basic-galaxies":
    "Once we expand into space, everyone gets an equal share of reachable cosmos.",
}

// A SECOND layperson sentence per policy — appended after POLICY_DESCRIPTIONS
// by the "more-text" hover-detail treatment (policyHoverSwap.tsx) to give the
// detail more body. Keep each ≤120 chars and standalone.
export const POLICY_EXTENDED_DESCRIPTIONS: Record<string, string> = {
  "baseline-ai-company-transparency":
    "Regulators stop depending on voluntary disclosures and can compare every lab against the same yardstick.",
  "massive-ai-alignment-subsidies":
    "The aim is thousands more researchers on the problem before the most dangerous capabilities arrive.",
  "us-china-chip-audit":
    "Neither side has to guess the other's compute, which makes a verified slowdown deal possible later.",
  "total-research-transparency":
    "With every experiment visible, neither side has to fear the other is secretly racing ahead.",
  "pause-on-ai-r-d":
    "It only works if every major power joins at once — a single defector and the halt collapses.",
  "safety-regulation-for-large-training-runs":
    "The threshold catches only the handful of frontier-scale runs, leaving smaller research untouched.",
  "compute-self-destruct-switches":
    "Because the switch is wired into the hardware itself, it works even if the software is compromised.",
  "cap-and-trade-for-robots-and-compute":
    "The cap makes the pace of automation a policy choice instead of a race no one can stop.",
  "citizen-s-dividend":
    "As AI displaces jobs, the dividend keeps household income tied to the economy's growth.",
  "universal-basic-galaxies":
    "Locking in equal shares now prevents whoever gets there first from owning the future outright.",
}
